module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.isGroup ? 'input-group' : '', 'autocomplete-outer'],
    attrs: {
      "id": 'autocomp-' + _vm._uid
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    style: (_vm.inputStyles),
    attrs: {
      "autocomplete": "off",
      "autofocus": _vm.autoFocus,
      "data-toggle": _vm.title ? 'tooltip' : '',
      "placeholder": _vm.placeHolder,
      "title": _vm.title,
      "type": "text",
      "id": _vm.acId
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, _vm.updating],
      "focus": function($event) {
        _vm.shouldShow = true
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "auto-complete-ul",
    style: (_vm.ulStyles),
    attrs: {
      "id": _vm.id
    }
  }, _vm._l((_vm.formattedDataset), function(match, i) {
    return _c('li', {
      class: [_vm.highlightIndex === i ? 'hover' : '', 'search-item'],
      on: {
        "mouseover": function($event) {
          _vm.highlightIndex = i
        },
        "click": function($event) {
          return _vm.searchSelect(match)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.value(match)) + "\n    ")])
  }), 0), _vm._v(" "), _vm._l((_vm.groupAddons), function(addon) {
    return (_vm.isGroup) ? _c('span', {
      staticClass: "input-group-addon"
    }, [_c('i', {
      class: ['fa', addon.icon],
      on: {
        "click": addon.fn
      }
    })]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c18ff7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/AutoComplete.vue
// module id = 2230
// module chunks = 1